<script>
import Navbar from "@/components/navbar";
import Features from "@/components/features";
import Services from "@/components/services";
import Contact from "@/components/contact";
import Footer from "@/components/footer";

/**
 * Index component
 */
export default {
  components: {
    Navbar,
    Features,
    Services,
    Contact,
    Footer,
  },
};
</script>
<template>
  <div>
    <Navbar />

    <div
      v-scroll-spy="{
        sectionSelector: '.section',
        offset: 450,
      }"
    >
      <!--START HOME-->
      <section
        class="section bg-home height-100vh"
        id="home"
        :style="{
          'background-image':
            'url(' + require('@/assets/images/bg-home.jpg') + ')',
          'background-size': 'cover',
          'background-position': 'center',
        }"
      >
        <div class="bg-overlay"></div>
        <div class>
          <div class>
            <div class="container slidero">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <h4 class="home-small-title">MODERN WEB SOLUTIONS</h4>
                  <h1 class="home-title">
                    From idea to implementation. We love making a better web.
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Particles -->
        <vue-particles class="position-relative" color="#FFF"></vue-particles>
      </section>
      <!--END HOME-->

      <section class="section-sm bg-light">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <p
                style="letter-spacing: 2px"
                class="text-center text-muted mb-4"
              >
                HAPPY CLIENTS
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-6">
              <div class="client-images my-3 my-md-0">
                <a
                  href="https://www.doctorweb.gr"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <img
                    src="@/assets/images/clients/1.png"
                    alt="logo-img"
                    class="mx-auto img-fluid d-block"
                  />
                </a>
              </div>
            </div>

            <div class="col-md-3 col-6">
              <div class="client-images my-3 my-md-0">
                <a
                  href="https://www.travelgirl.gr"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <img
                    src="@/assets/images/clients/2.png"
                    alt="logo-img"
                    class="mx-auto img-fluid d-block"
                  />
                </a>
              </div>
            </div>

            <div class="col-md-3 col-6">
              <div class="client-images my-3 my-md-0">
                <a
                  href="https://www.matchframe.gr"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <img
                    src="@/assets/images/clients/3.png"
                    alt="logo-img"
                    class="mx-auto img-fluid d-block"
                  />
                </a>
              </div>
            </div>

            <div class="col-md-3 col-6">
              <div class="client-images my-3 my-md-0">
                <a
                  href="https://www.mhanksgallery.com"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <img
                    src="@/assets/images/clients/4.png"
                    alt="logo-img"
                    class="mx-auto img-fluid d-block"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Features />
      <Services />
      <Contact />
      <Footer />
    </div>
  </div>
</template>

<style scoped>
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
</style>